import {
  getInsightsTermsByIdUrl,
  getInsightsTermsUrl,
  getTermsUrl,
} from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class TermService {
  static getTerms = ({ noPastTerms = false, onlyFutureTerms = false } = {}) => {
    const params = Object.assign(
      {},
      !!noPastTerms && { noPastTerms: true },
      !!onlyFutureTerms && { onlyFutureTerms: true }
    );

    return getRequest(getTermsUrl(), params);
  };

  static getInsightsTerms = () => {
    return getRequest(getInsightsTermsUrl());
  };

  static updateInsightsTerm = (termId, params) => {
    return putRequest(getInsightsTermsByIdUrl(termId), params);
  };

  static createInsightsTerm = (params) => {
    return postRequest(getInsightsTermsUrl(), params);
  };

  static deleteInsightsTerm = (termId) => {
    return deleteRequest(getInsightsTermsByIdUrl(termId));
  };
}
